import { ScrollReveal } from "../Reveal";

const countries = [
  { name: "United States", type: "ESTA", code: "US" },
  { name: "Canada", type: "eTA", code: "CA" },
  { name: "Australia", type: "ETA / eVisitor", code: "AU" },
  { name: "New Zealand", type: "NZeTA", code: "NZ" },
  { name: "United Arab Emirates", type: "Visa on Arrival", code: "AE" },
  { name: "Turkey", type: "e-Visa", code: "TR" },
  { name: "Singapore", type: "SG Arrival Card", code: "SG" },
  { name: "Thailand", type: "TDAC / Visa on Arrival", code: "TH" },
  { name: "Sri Lanka", type: "ETA", code: "LK" },
  { name: "Kenya", type: "eTA", code: "KE" },
  { name: "Egypt", type: "e-Visa", code: "EG" },
  { name: "Vietnam", type: "e-Visa", code: "VN" },
  { name: "Cambodia", type: "e-Visa", code: "KH" },
  { name: "Indonesia (Bali)", type: "Visa on Arrival", code: "ID" },
  { name: "Schengen Area", type: "ETIAS / Short-Stay", code: "EU" },
  { name: "India", type: "e-Visa / OCI", code: "IN" },
];

export default function GlobalServices() {
  return (
    <section id="global" className="relative bg-navy-800 py-24 md:py-40 overflow-hidden" data-testid="global-services-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-8">
          <ScrollReveal className="col-span-12 md:col-span-5">
            <h2 className="font-display font-light text-ivory text-5xl md:text-7xl lg:text-8xl leading-[0.9] tracking-tight">
              Global <br />
              <span className="italic text-gold">Services</span>
            </h2>
            <p className="mt-8 max-w-md text-ivory/60 leading-relaxed">
              Electronic travel authorisations, digital arrival forms, and
              visas-on-arrival — coordinated on your behalf so you arrive
              paperwork-free.
            </p>
          </ScrollReveal>

          <div className="col-span-12 md:col-span-7">
            <ScrollReveal>
              <div className="font-mono-ui font-bold text-base md:text-lg tracking-[0.24em] text-gold uppercase mb-6 flex justify-between">
                <span>Destination</span>
                <span>Authorisation</span>
              </div>
            </ScrollReveal>
            <ul className="divide-y divide-ivory/10 border-t border-ivory/10 border-b">
              {countries.map((c, idx) => (
                <ScrollReveal key={c.name} delay={idx * 0.03}>
                  <li
                    className="group flex items-center justify-between py-5 hover:pl-4 transition-all duration-500 cursor-default"
                    data-testid={`country-row-${c.code.toLowerCase()}`}
                  >
                    <div className="flex items-baseline gap-6">
                      <span className="font-mono-ui text-sm text-gold/70 tabular-nums">
                        {String(idx + 1).padStart(2, "0")}
                      </span>
                      <span className="font-display text-2xl md:text-3xl text-ivory group-hover:italic group-hover:text-gold transition-all duration-300">
                        {c.name}
                      </span>
                    </div>
                    <span className="font-mono-ui text-sm md:text-base tracking-[0.18em] uppercase text-ivory/70 group-hover:text-ivory transition-colors">
                      {c.type}
                    </span>
                  </li>
                </ScrollReveal>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
